import { Identifier } from "./id";
/**
 * ID of a Restaurant
 */
export class RestaurantId extends Identifier {
    constructor(id) {
        super("RestaurantId", id);
    }
}
